import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";
import {
  chipVerdict,
  type CacheFields,
  type CacheVerdict,
} from "@/lib/cacheVerdict";

/** Warm-cache chip from an already computed verdict. */
export function CacheVerdictChip({
  verdict,
  className,
}: {
  verdict: CacheVerdict;
  className?: string;
}) {
  return (
    <Badge
      variant={verdict.tone}
      title={verdict.title}
      data-testid="cache-chip"
      data-cache={verdict.kind}
      className={cn(
        "cursor-help whitespace-nowrap px-1.5 py-0 text-[11px] font-medium",
        className,
      )}
    >
      {verdict.label}
    </Badge>
  );
}

/** Chip for a job row (registry attempt builds, sibling lists): nothing
 *  while the job is unfinished, `unknown` when a succeeded job has no data. */
export function CacheChip({
  job,
  className,
}: {
  job: CacheFields & {
    status?: string;
    build_kind?: string | null;
    pgo_generate?: number | null;
    pgo_profile_path?: string | null;
  };
  className?: string;
}) {
  const v = chipVerdict(job);
  return v ? <CacheVerdictChip verdict={v} className={className} /> : null;
}
